import IService from '../IService';
import _ from 'lodash-extended';

export default IService.extend({
  cache: new Map(),

  getStyleImage({ programmerId, brandId }) {
    if (!_.isNumeric(programmerId) || !_.isNumeric(brandId)) {
      app.doctorController.report('programmers.getStyleImage - bad arguments');
    }

    const cacheKey = `p:${programmerId}/b:${brandId}`;

    if (!this.cache.has(cacheKey)) {
      this.cache.set(
        cacheKey,
        new Promise((resolve, reject) => {
          $.ajax({
            url: app.apiUrl(
              `/api/v1/programmers/${programmerId}/brands/${brandId}/styles`
            ),
            type: 'GET',

            error: (jqXHR, textStatus) => {
              if (textStatus !== 'abort') {
                reject({ programmerId, brandId, ...this.createError(jqXHR) });
              }
            },

            dataType: 'json',
            success(res) {
              if (_.isPlainObject(res) && !_.isEmpty(res.url)) {
                resolve({
                  programmerId,
                  brandId,
                  url: res.url,
                });
              } else {
                reject({
                  programmerId,
                  brandId,
                  error: 'UNSUPPORTED_RESPONSE_FORMAT',
                });
              }
            },
          });
        })
      );
    }

    return this.cache.get(cacheKey);
  },
});
